module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "headerTitle clearfix"
  }, [_c('div', {
    staticClass: "header-wrap",
    staticStyle: {
      "width": "1200px",
      "margin": "auto",
      "height": "50px"
    }
  }, [_c('ul', [_c('li', {
    staticClass: "headerTitle-list-default tab clearfix",
    on: {
      "mouseenter": function($event) {
        $event.stopPropagation();
        return _vm.leave()
      },
      "click": function($event) {
        $event.stopPropagation();
        return _vm.leave()
      }
    }
  }, [_c('div', {
    staticClass: "title-tab-container clearfix"
  }, [_c('div', {
    staticClass: "title-logo clearfix",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.$router.go('/moduleOption')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/logo.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "title-tab clearfix"
  }, [(_vm.userInfo.role && (_vm.userInfo.role.roleCode == 'teacher' || _vm.userInfo.role.roleCode == 'dean')) ? _c('ul', [_c('li', {
    staticClass: "list-default",
    class: [this.$route.meta.title == '首页' ? 'active' : ''],
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.goHome()
      }
    }
  }, [_vm._v("首页\n              ")]), _vm._v(" "), _c('li', {
    staticClass: "list-default",
    class: [this.$route.meta.title == '试题库' ? 'active' : ''],
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.goTopiclibrary()
      }
    }
  }, [_vm._v("试题库\n              ")]), _vm._v(" "), _c('li', {
    staticClass: "list-default",
    class: [this.$route.meta.title == '试卷库' ? 'active' : ''],
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.goPaperlibrary()
      }
    }
  }, [_vm._v("试卷库\n              ")]), _vm._v(" "), _c('li', {
    staticClass: "list-default",
    class: [this.$route.meta.title == '成绩管理' ? 'active' : ''],
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.goScoreManagement()
      }
    }
  }, [_vm._v("成绩管理\n              ")])]) : _vm._e(), _vm._v(" "), (_vm.userInfo.role && _vm.userInfo.role.roleCode == 'appadmin') ? _c('ul', [_c('li', {
    staticClass: "list-default",
    class: [this.$route.meta.title == '首页' ? 'active' : ''],
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.goHomePage()
      }
    }
  }, [_vm._v("首页\n              ")]), _vm._v(" "), _c('li', {
    staticClass: "list-default",
    class: [this.$route.meta.title == '资源管理' ? 'active' : ''],
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.gotoResources()
      }
    }
  }, [_vm._v("资源管理\n              ")]), _vm._v(" "), _c('li', {
    staticClass: "list-default",
    class: [this.$route.meta.title == '习题组卷' ? 'active' : ''],
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.goGroupPaper()
      }
    }
  }, [_vm._v("习题组卷\n              ")]), _vm._v(" "), _c('li', {
    staticClass: "list-default",
    class: [this.$route.meta.title == '成绩管理' ? 'active' : ''],
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.goScoreManagement()
      }
    }
  }, [_vm._v("成绩管理\n              ")]), _vm._v(" "), _c('li', {
    staticClass: "list-default",
    class: [this.$route.meta.title == '统计分析' ? 'active' : ''],
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.goStatisticalAnalysis()
      }
    }
  }, [_vm._v("统计分析\n              ")]), _vm._v(" "), _c('li', {
    staticClass: "list-default",
    class: [this.$route.meta.title == '使用分析' ? 'active' : ''],
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.goUseAnalysis()
      }
    }
  }, [_vm._v("使用分析\n              ")]), _vm._v(" "), _c('li', {
    staticClass: "list-default",
    class: [this.$route.meta.title == '学生管理' ? 'active' : ''],
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.goStudent()
      }
    }
  }, [_vm._v("学生\n              ")])]) : _vm._e()])])]), _vm._v(" "), (!(_vm.userInfo.role == undefined || (_vm.userInfo.role && _vm.userInfo.role.roleCode == 'student'))) ? [_c('li', {
    staticClass: "headerTitle-list-default"
  }, [_c('div', {
    class: !_vm.clickExerBasketFlag ? 'exer-basket' : 'exer-basket-click',
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.clickExerBasket()
      }
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "exer-basket-name"
  }, [_vm._v("试题篮")]), _vm._v(" "), _c('div', {
    staticClass: "exer-basket-count"
  }, [_vm._v(_vm._s(_vm.exerciseCount))])])])] : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "headerTitle-list-default dropwindow clearfix"
  }, [_c('div', {
    staticClass: "drop-btn",
    staticStyle: {
      "display": "flex"
    }
  }, [_c('div', {
    staticClass: "drop-img"
  }, [_c('div', {
    staticClass: "personal-content"
  }, [_c('div', {
    staticClass: "personal-left"
  }, [_c('div', {
    staticClass: "personal-left-img"
  }, [_c('div', {
    staticClass: "personal-img-border"
  }, [_c('el-upload', {
    staticClass: "fileInputContainer",
    attrs: {
      "action": _vm.uurl,
      "http-request": _vm.uploadImage,
      "before-upload": _vm.beforeAvatarUpload,
      "show-file-list": false
    }
  }, [_c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.showThumbPath(_vm.userInfo.photo),
      "onerror": _vm.headerPic
    }
  })])], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "drop-name",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.showdropwindow(1)
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.userInfo.name) + "\n          ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.dropwindow),
      expression: "dropwindow"
    }],
    staticClass: "drop-down animated"
  }, [_c('div', {
    staticClass: "drop-content"
  }, [_c('div', {
    staticClass: "ip clearfix "
  }, [_vm._v("\n                " + _vm._s(this.serverIp) + "\n              ")]), _vm._v(" "), _vm._l((_vm.navlists), function(navlist) {
    return _c('div', {
      staticClass: "navlist clearfix",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm._goto(navlist.to)
        }
      }
    }, [_c('span', {
      staticClass: "icon iconfont icon-yuechi"
    }), _vm._v(" "), _c('span', {
      staticClass: "list-text"
    }, [_vm._v("修改密码")])])
  }), _vm._v(" "), _vm._l((_vm.navlists), function(navlist) {
    return (_vm.userInfo.role && (_vm.userInfo.role.roleCode == 'teacher' || _vm.userInfo.role.roleCode == 'dean')) ? _c('div', {
      staticClass: "navlist clearfix",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.jumpPersonalManagement(navlist.to)
        }
      }
    }, [_c('span', {
      staticClass: "icon iconfont icon-yuechi"
    }), _vm._v(" "), _c('span', {
      staticClass: "list-text"
    }, [_vm._v("个人管理")])]) : _vm._e()
  }), _vm._v(" "), _c('div', {
    staticClass: "navlist clearfix",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm._logout()
      }
    }
  }, [_c('span', {
    staticClass: "icon iconfont icon-tuichu1"
  }), _vm._v(" "), _c('span', {
    staticClass: "list-text"
  }, [_vm._v("退出账户")])])], 2)])])])], 2)]), _vm._v(" "), (_vm.userInfo.role && _vm.userInfo.role.roleCode != 'student') ? _c('div', {
    staticStyle: {
      "width": "1200px",
      "margin": "auto"
    }
  }, [_c('ul', [(this.$route.meta.title != '学测主页') ? _c('li', {
    staticClass: "headerTitle-list-default navigation clearfix",
    on: {
      "mouseenter": function($event) {
        $event.stopPropagation();
        return _vm.leave()
      },
      "click": function($event) {
        $event.stopPropagation();
        return _vm.leave()
      }
    }
  }, [_c('ExamBreadcrumb')], 1) : _vm._e()]), _vm._v(" "), (_vm.userInfo.role && (_vm.userInfo.role.roleCode == 'teacher' || _vm.userInfo.role.roleCode == 'dean')) ? _c('div', {
    staticClass: "com-layout-c-c-c",
    staticStyle: {
      "width": "54px",
      "height": "30px",
      "font-size": "12px",
      "font-family": "Microsoft YaHei",
      "font-weight": "300",
      "color": "rgba(170,170,170,1)",
      "float": "right",
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.showNovice()
      }
    }
  }, [_vm._v("\n      新手指引\n    ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.showShare) ? _c('div', {
    staticClass: "edit-background"
  }, [_c('Personal', {
    ref: "editLibrary",
    on: {
      "closePage": _vm.closePage
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', [_c('ExerBasket', {
    ref: "exerBasketRef",
    on: {
      "changeClickExerBasketFlag": _vm.changeClickExerBasketFlag
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "exer-basket-icon"
  }, [_c('i', {
    staticClass: "iconfont el-icon-shopping-cart-full iconfont1"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5c9d962c"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/Headers.vue
// module id = 552
// module chunks = 93